let Photos1970=[
  {
    "NameEN": "1970",
    "Image": "un16",
    "CaptionEN": "Man sitting on \"Europeans only\" bench in South Africa, 1970 [Getty Images]",
    "CaptionAR": "رجل يجلس قرب لوحة \"للأوروبيين فقط\" عام 1970 خلال حقبة نظام الفصل العنصري في جنوب أفريقيا (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un19",
    "CaptionEN": "A UNICEF concert is held at the General Assembly, 1979 [Getty Images]",
    "CaptionAR": "حفل لمنظمة اليونيسيف خلال أعمال الجمعية العامة عام 1979 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un18",
    "CaptionEN": "Sadat, Begin and Carter signing the Camp David Accords, 1979 [Getty Images]\n",
    "CaptionAR": "السادات وبيغن وكارتر يوقعون على اتفاقية كامب ديفد عام 1979 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un6",
    "CaptionEN": "China's Deputy Foreign Minister, Chiao Kuan-hua and Vice Premier Tung Hsiao Ping attend the General Assembly, 1974 [Getty Images]",
    "CaptionAR": "الزعيم الصيني دينغ هسياو بينغ ونائب وزير الخارجية تشياو كوان هوا يشاركان في جلسة الجمعية العامة عام 1974 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un17",
    "CaptionEN": "Palestinian leader Yasser Arafat, 1974 [Getty Images]",
    "CaptionAR": "الزعيم الفلسطيني ياسر عرفات عام 1974 (غيتي)"
  }
]
export default Photos1970